module.exports = __webpack_public_path__ + "img/ins.51cdbff6.svg";